<template>
    <div class="upload">
        <el-upload action="" :http-request="toUpload" :before-upload="beforeAvatarUpload" :show-file-list="false">
            <el-button size="small" type="primary" class="upBtn">点击上传</el-button>
            <span slot="tip" class="tip">只能上传jpg/png/jpeg格式，且不超过2MB</span>
        </el-upload>
        <el-image class="elImg" v-if="imageUrl" :src="imageUrl" :preview-src-list="srcList"></el-image>
    </div>
</template>

<script>
export default {
    props: {
        imgUrls: {
            type: String,
            default: '',
        }
    },
    components: {},
    computed: {},
    watch: {
        imgUrls(url) {
            console.log(url);
            this.imageUrl = url;
            this.srcList = [url];
        }
    },
    data() {
        return {
            imageUrl: this.imgUrls,
            srcList: [this.imgUrls]
        }
    },
    created() { },
    methods: {
        toUpload(file) {
            let _this = this;
            let [multipartFile] = [file.file];
            let fd = new FormData();
            fd.append('businessType', '1');
            fd.append('multipartFiles', multipartFile);
            fd.append('userId', '0');
            this.$https.post('system/uploadImg', fd).then(res => {
                // console.log(res);
                if (res.code == 200) {
                    _this.imageUrl = res.data[0];
                    _this.srcList[0] = res.data[0];
                    _this.$emit('getImgUrl', res.data[0]);
                } else {

                }
            })
            // .catch(res => {
            //     
            // })
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;
            const isName = file.name.length > 3;
            if (!isJPG) {
                this.$message.error('图片只能上传 PNG、JPG、JPEG 格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('图片大小不能超过 2MB!');
                return false;
            }
            // return true;
            return isJPG && isLt2M; // && isName
        }
    },
}
</script>

<style lang="less" scoped>
.upBtn {
    display: block;
    margin-bottom: 10px;
}
.elImg {
    width: 100px;
    height: 100px;
}
.upload > div,
.upload /deep/ .el-form-item--small .el-form-item__label,
.upload /deep/ .el-upload,
.upload /deep/ .el-form-item__content {
    line-height: normal !important;
}
.upload /deep/ .el-image-viewer__btn {
    background: #fff;
}
.tip {
    font-size: 12px;
    margin-left: 10px;
    color: grey;
}
</style>
